import { useSelector } from 'store';
import { Contact } from 'types/contact';
import makeAccessLink from 'utils/makeAccessLink';
import useSetPath from './data-saving/useSetPath';
import useSendEmail, { FirebaseEmail } from './useSendEmail';
import useHandleAccess from './data-saving/useHandleAccess';
import useErrorSnackbar from './useErrorSnackbar';

export default function useSendOnboarding() {
  const { emailTemplates } = useSelector((state) => state.config.mainConfig);
  const sendEmail = useSendEmail();
  const setPath = useSetPath();
  const handleAccess = useHandleAccess();
  const errorSnackbar = useErrorSnackbar();

  const sendOnboarding = (contact: Contact) => {
    if (!contact.email1) {
      return errorSnackbar({
        message: `No email found for one or more onboarding messages`
      } as Error);
    }
    handleAccess(contact.email1, true);
    let emailObject, template;
    if (contact.accountTypes?.includes?.('Staff')) {
      template = emailTemplates.find((template) => template.name === 'Onboarding - Talent');
      if (!template) return;
      emailObject = {
        message: {
          subject: template.subject,
          html: template.html
        }
      };
    } else if (contact.accountTypes?.includes?.('Client')) {
      template = emailTemplates.find((template) => template.name === 'Onboarding - Client');
      if (!template) return;
      emailObject = {
        message: {
          subject: template.subject,
          html: template.html
        }
      };
    } else if (contact.accountTypes?.includes?.('Talent')) {
      template = emailTemplates.find((template) => template.name === 'Onboarding - Talent');
      if (!template) return;
      emailObject = {
        message: {
          subject: template.subject,
          html: template.html
        }
      };
    }

    if (!emailObject) return;

    const accessLink = makeAccessLink(contact.email1 || '', contact.accountTypes).message;

    emailObject.message.html = emailObject.message.html + accessLink;

    const email: FirebaseEmail = {
      to: contact.email1 || '',
      ...emailObject
    };

    sendEmail(email);
    setPath(`contacts/${contact.id}`, { onboardingSent: new Date() });
  };

  return sendOnboarding;
}
